export default {
  namespaced: true,
  state() {
    return {
      isOn: false,
      isComponent: ""
    }
  },

  getters: {
    isOn(state) {
      return state.isOn
    },
    isComponent(state) {
      return state.isComponent
    }
  },
  mutations: {
    toggleSideSheet(state, payload) {
      payload.isOn === undefined ? (state.isOn = !state.isOn) : (state.isOn = payload.isOn)
      payload.isComponent !== undefined && (state.isComponent = payload.isComponent)
    },

    resetComponent(state) {
      state.isComponent = ""
    }
  },
  actions: {
    toggleSideSheet({ commit }, payload) {
      commit("toggleSideSheet", payload)
    },

    resetComponent({ commit }) {
      commit("resetComponent")
    }
  }
}
